import React from 'react'
import cx from 'classnames'

import { Icon, InfoIcon } from 'components/shared/Icon/Icon'

import styles from './CategoryCard.module.scss'

export const CategoryCard = ({
  activeCategory,
  category,
  children,
  onClick,
}) => (
  <div
    className={cx(styles.card, {
      [styles.active]: category === activeCategory,
    })}
  >
    <button
      className={styles.category}
      type="button"
      onClick={onClick(category)}
    >
      <span className={styles.content}>
        <span className={styles.label}>{category}</span>
        <Icon className={styles.icon} icon={InfoIcon} size={16} />
      </span>
    </button>
    {children}
  </div>
)
